import "./About.css";
import aboutImg from "../../../images/Operating system-bro.png";

const About = () => {
  return (
    <div
      className="about-bg"
      // data-aos="fade-down-left"

      // data-aos-duration="1000"
    >
      <div id="about" className="container ">
        <div className="heading-section">
          <h4 className="mb-3 fw-bold">About Me</h4>
        </div>
        <div className="row ">
          <div className="col-md-5 col-12">
            <div className="pr-5">
              <img src='https://i.ibb.co/NmHvrhG/262402659-1735915976601927-4074890799033005079-n-removebg-preview.png' className="z-0 rounded" alt="About-img" width={350} height={400} />
              {/* <ul>
                                <li className="about-list info fw-bold ">Personal Info</li>

                                <li className="about-list">Name : <span className="info">Sahara Banu</span></li>

                                <li className="about-list">Age: <span className="info">27+</span></li>

                                <li className="about-list">Phone : <span className="info">01752810246</span></li>
                                <li className="about-list">Email: <span className="info">saharabanungn@gmail.com</span></li>
                                 <li className="about-list">GitHub:  <span className="info">https://github.com/saharabanu</span></li> 
                               
                                <li className="about-list">Qualification: <span className="info">Masters of Arts(English)</span></li>
                                <li className="about-list">Language: <span  className="info">Bangla,English</span></li>
                                <li className="about-list">Nationality:  <span  className="info">Bangladeshi</span> </li>
                            </ul> */}
            </div>
          </div>

          <div className="col-md-7 col-12">
          <div className="ps-5">
              {/* <h3>
                I am <span className="">Frontend Developer</span>{" "}
              </h3> */}
              <p className="text-start py-4">
                As salamu alaikum Orohmatullah! I'm Sahara Banu as a Professional Frontend Developer
                from Bangladesh. Thanks for scrolling this far!! 🤗 My Background however has always
                been design-driving. I've always been excited with the idea of crafting something
                that people can interact with. Anyway I am frontend web developer with solid
                knowledge in different Technology & enough experience and creating & designing super
                responsive website.I love writing clean code, and pushing my skills to the limit. My interests include
                joining an exciting team of passionate people, personal growth, and making silly
                faces. I have also worked in a team for two months for creating a Multivendor
                E-commerce website.I love writing clean code, and pushing my skills to the limit. My interests include
                joining an exciting team of passionate people, personal growth, and making silly
                faces. I have also worked in a team for two months for creating a Multi vendor
                E-commerce website.
              </p>
              

              
              <br />
              {/* <Link to="/skills">
                <button className="btn btn-danger rounded-pill px-3">About More</button>
              </Link> */}
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;



